<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/sMRlRd/tc-custom/9781467449564.jpg?1744436680818" alt="This image is the cover for the book This Incredibly Benevolent Force"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">This Incredibly Benevolent Force
      </h1>
      <p class="bookDescription body article font2">
        <p>A key refrain in Reformed theology is that God’s Spirit trumpets the message of salvation through Jesus Christ into every nook and cranny of the universe—but how? And in what way does this cosmic truth touch and shape the mundane reality of our lives and our world?</p><p>In this distillation of his Warfield Lectures, delivered at Princeton Theological Seminary in spring 2014, leading Reformed theologian Cornelis van der Kooi examines the relationship of the Holy Spirit to Jesus Christ. He demonstrates how a fuller understanding of the interplay between Christology and pneumatology can encourage the Christian church to have open eyes and ears for the inbreaking of God’s “incredibly benevolent force” into the cosmological emptiness of today’s world.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        C. Van der Kooi
      </h2>
      
      <p class="authorDescription body article"><B>Cornelis van der Kooi</B>&#160;is professor of systematic theology and director of the Center for Evangelical and Reformation Theology at the Free University of Amsterdam.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      William B. Eerdmans Publishing Company
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?96a8199a